import ApolloClient from "../apollo";
import { createError } from "../graphql-local/unexpectedError";

export const detectUnexpectedError = ({ expected } = { expected: [] }) => error => {
	if (!expected.includes(error.code)) {
		ApolloClient().writeData({
			data: {
				unexpectedError: createError(error),
			},
		});
	}
	return Promise.reject(error);
};
